import { RestSchemas } from '@/contexts/QueryProvider'
import { formatPersonName } from '@/pages/Subscriptions/Requests/types'

export type TicketLookupMaps = {
  userNames: Map<number, string>
  applicationNames: Map<number, string>
  roleNames: Map<number, string>
  roleNamesByApplication: Map<number, Map<number, string>>
  organisationNames: Map<number, string>
  projectNames: Map<number, string>
}

export const EMPTY_TICKET_LOOKUPS: TicketLookupMaps = {
  userNames: new Map(),
  applicationNames: new Map(),
  roleNames: new Map(),
  roleNamesByApplication: new Map(),
  organisationNames: new Map(),
  projectNames: new Map(),
}

type RequestLookups = RestSchemas['Messages.Requests.RequestLookups']

export function buildTicketLookupMaps(lookups: RequestLookups | undefined): TicketLookupMaps {
  const maps: TicketLookupMaps = {
    userNames: new Map(),
    applicationNames: new Map(),
    roleNames: new Map(),
    roleNamesByApplication: new Map(),
    organisationNames: new Map(),
    projectNames: new Map(),
  }

  for (const user of lookups?.users ?? []) {
    const label = formatPersonName(user.givenName, user.familyName, user.email)
    if (label) maps.userNames.set(user.id, label)
  }

  for (const organisation of lookups?.organisations ?? []) {
    maps.organisationNames.set(organisation.id, organisation.name)
  }

  for (const project of lookups?.projects ?? []) {
    maps.projectNames.set(project.id, project.name)
  }

  for (const application of lookups?.applications ?? []) {
    maps.applicationNames.set(application.id, application.name)
  }

  for (const role of lookups?.roles ?? []) {
    maps.roleNames.set(role.id, role.name)
    const applicationRoles = maps.roleNamesByApplication.get(role.applicationId) ?? new Map<number, string>()
    applicationRoles.set(role.id, role.name)
    maps.roleNamesByApplication.set(role.applicationId, applicationRoles)
  }

  return maps
}

export function formatMappedName(id: number | null | undefined, names: Map<number, string>, fallbackPrefix: string): string {
  if (id == null) return '—'
  return names.get(id) ?? `${fallbackPrefix} #${id}`
}
